<template>
<div>

    <div class="box partner-box" @click="partner_modal = true">
        <img src="https://assets.webbank.com/domain_money.png" alt="Domain Money Logo">
    </div>

<div class="modal" :class="{'is-active': partner_modal}">
  <div class="modal-background"></div>
  <div class="modal-content">
      <div class="box has-text-left">
          <h2 class="box-title">Our Brand Partner</h2>
          <br>
          <div class="has-text-centered">
            <img src="https://assets.webbank.com/domain_money.png" alt="Domain Money Logo">
          </div>
            <br>
            <p>In partnership with Domain Money, WebBank provides banking services to Domain Money customers. All cash held by Domain Money customers in their Domain Money Deposit Account is held in a WebBank Deposit Account. If you are interested in learning more about Domain Money, please click.
                <a href="#" title="Visit Domain Money" @click="$emit('link-click', 'https://try.domainmoney.com/')">here</a>.</p>
            <br>
            <p><a href="#" title="Domain Money Privacy Policy" @click="$emit('link-click', 'https://domainmoney.com/privacy-policy')">Domain Money Privacy Policy</a></p>
            <br>
            <p><a href="#" title="Domain Money Privacy Notice" @click="$emit('link-click', 'https://domainmoney.com/assets/library/dm-glba')">Domain Money Privacy Notice</a></p>
            <br>
            <button class="button is-primary is-light" @click="partner_modal = false">Close</button>

      </div>
  </div>
  <button class="modal-close is-large" aria-label="close" @click="partner_modal = false"></button>
</div>

</div>
</template>

<script>
export default {
    data: function () {
        return {
            partner_modal: false,
        }
    }
}
</script>
